import { render, staticRenderFns } from "./PartnerAddressForm.vue?vue&type=template&id=c3bf5b7a&"
import script from "./PartnerAddressForm.vue?vue&type=script&lang=js&"
export * from "./PartnerAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports